// client\src\components\ChatGPT.jsx

import { useState } from 'react';
import './App.css';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { MainContainer, ChatContainer, MessageList, Message, MessageInput, TypingIndicator } from '@chatscope/chat-ui-kit-react';
import { FaDatabase, FaWpforms, FaGlobe } from "react-icons/fa";

const API_KEY = "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";

const systemMessage = {
  role: "system",
  content: "Você é uma empresa especializada em vistos americanos de turismo. Responda de forma clara e objetiva as perguntas feitas. Caso o cliente peça por um contato humando informe sobre meu telefone de contato +55(61)996011975"
};

function ChatGPT({ contextMessage }) {

  const [messages, setMessages] = useState([
    {
      message: "Oi, eu sou seu assistente virtual! Pergunte qualquer coisa sobre vistos americanos!",
      sender: "I.A."
    }
  ]);
  const [isTyping, setIsTyping] = useState(false);

  const handleSend = async (message) => {
    const newMessage = { message, sender: "user" };
    const updatedMessages = [...messages, newMessage];
    setMessages(updatedMessages);
    setIsTyping(true);
    await fetchResponse(updatedMessages);
  };

const fetchResponse = async (chatMessages) => {
  const apiMessages = chatMessages.map(msg => ({
    role: msg.sender === "I.A." ? "assistant" : "user",
    content: msg.message
  }));




  const requestBody = {
    model: "gpt-5-mini-2025-08-07",
    messages: [systemMessage, contextMessage, ...apiMessages] // Inclui os dados do JSON antes das mensagens
  };

  try {
    const response = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${API_KEY}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(requestBody)
    });
    const data = await response.json();
    setMessages([...chatMessages, { message: data.choices[0].message.content, sender: "I.A." }]);
  } catch (error) {
    console.error("Erro ao obter resposta da IA:", error);
  }
  setIsTyping(false);
};


  return (
    <div className="chat-container">
      <div
        style={{
          // padding: "10px",
          textAlign: "center",

        }}
      >
        <img src="\memoji\lampada.webp" alt="Logo I.A." style={{ width: '170px', height: 'auto', marginTop: "-40px" }} />
      </div>
      <div
        style={{
          padding: "10px",
          borderRadius: "20px",
          textAlign: "center"
        }}
      >
        <h2>Pergunte ao Gabriel (I.A.)</h2>
        <p>Nossa Inteligência Artificial treinada.</p>
      </div>

      {/* <div className="info-container" style={{ display: "flex", justifyContent: "space-around", padding: "20px" }}>
        <div className="info-box" style={{ textAlign: "center" }}>
          <FaDatabase size={40} color="rgb(192 192 192)" />
          <p>Treinada com milhares de solicitações.</p>
        </div>
        <div className="info-box" style={{ textAlign: "center" }}>
          <FaWpforms size={40} color="rgb(192 192 192)" />
          <p>Acesso as suas demandas.</p>
        </div>
        <div className="info-box" style={{ textAlign: "center" }}>
          <FaGlobe size={40} color="rgb(192 192 192) " />
          <p>Organize suas tarefas ou tire duvidas.</p>
        </div>
      </div> */}

      <MainContainer style={{ height: "auto" }}>
        <ChatContainer>
          <MessageList
            scrollBehavior="smooth"
            typingIndicator={isTyping ? <TypingIndicator content="A I.A. está digitando..." /> : null}
          >
            {messages.map((msg, i) => (
              <Message
                key={i}
                model={{ message: msg.message, direction: msg.sender === "user" ? "outgoing" : "incoming" }}
                className={msg.sender === "user" ? "message user" : "message assistant"}
              />
            ))}
          </MessageList>
          <MessageInput placeholder="Digite sua pergunta aqui..." onSend={handleSend} />
        </ChatContainer>
      </MainContainer>
    </div>
  );
}

export default ChatGPT;
